import { render, staticRenderFns } from "./CustomerCreditCardTab.vue?vue&type=template&id=03c0689e&scoped=true&"
import script from "./CustomerCreditCardTab.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditCardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c0689e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
